/* ============================================================
   NORTHSHEEP — Collection card curation (reorder + hide + favourite)
   Superset of ns-collection-reorder.js, loaded INSTEAD of it when the
   "swipe to hide & favourite" feature is on (so the plain reorder file stays
   untouched). Two gesture modes (set per grid via data-ns-actions):
     - "swipe": flick left = hide, right = favourite; hold = reorder.
     - "zones": hold to lift, drop on the bin (hide) or heart (favourite).
   Hidden products are a cross-collection block-list (window.NsCurate) and
   vanish on every collection until un-hidden. No libraries.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsCollectionReorderLoaded) return;
  window.__nsCollectionReorderLoaded = true;

  var ORDER_PREFIX = 'northsheep_collection_order_';
  var HIDDEN_KEY = 'northsheep_hidden_products';

  function lsOk() { try { localStorage.setItem('__nscu__', '1'); localStorage.removeItem('__nscu__'); return true; } catch (e) { return false; } }
  var LS = lsOk();

  // ---------- hidden block-list (cross-collection) -> window.NsCurate ----------
  function readHidden() {
    if (!LS) return [];
    try { var a = JSON.parse(localStorage.getItem(HIDDEN_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function writeHidden(a) { if (LS) { try { localStorage.setItem(HIDDEN_KEY, JSON.stringify(a)); } catch (e) {} } }
  var lastHidden = null;

  /* NO HEART STAMP ON A SAVE (owner, 20 Sep 2026: "i feel like the stamp is
     unnesicarry as the like stays on the image so get rid of it and its
     code").

     It was built, tried at three sizes and two positions, and taken out
     again: the saved state is PERSISTENT — the heart stays red on the card
     for the rest of the visit — so an animation confirming it is decoration
     on top of an answer that is already sitting there. Kept here only as a
     note, so the idea is not rediscovered and rebuilt in six months.

     The one-time swipe lesson draws its own large heart; that one is teaching
     a gesture, not confirming a save. See ns-fav-swipe-hint.js. */

  // Tiny toast (its own element; styled by ns-collection-curate.css).
  var toastEl = null, toastTimer = null;
  /* The store's own words, printed on the grid by the section (audit, 2 Oct
     2026): the hide toast said "Product hidden" / "Undo" on all five stores. */
  function gridText(name, fallback) {
    var g = document.getElementById('product-grid');
    return (g && g.getAttribute(name)) || fallback;
  }
  function toast(msg, actionLabel, onAction) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ns-curate-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="ns-curate-toast__msg"></span>';
    toastEl.querySelector('.ns-curate-toast__msg').textContent = msg;
    if (actionLabel) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ns-curate-toast__action';
      b.textContent = actionLabel;
      b.addEventListener('click', function () { hideToast(); if (onAction) onAction(); });
      toastEl.appendChild(b);
    }
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-visible'); }

  /* immediate=true means "show products again NOW" (unhide, reset). A plain
     hide defers its top-up until the shopper scrolls near the end. */
  function notifyChange(immediate) {
    try {
      document.dispatchEvent(new CustomEvent('ns:hidden-changed', {
        detail: { immediate: !!immediate }
      }));
    } catch (e) {}
    document.querySelectorAll('ul#product-grid[data-ns-actions]').forEach(function (g) { applyHidden(g); });
  }

  var NsCurate = {
    list: function () { return readHidden(); },
    isHidden: function (h) { return h && readHidden().indexOf(h) !== -1; },
    hide: function (h, opts) {
      if (!h) return;
      var a = readHidden();
      if (a.indexOf(h) === -1) { a.push(h); writeHidden(a); }
      lastHidden = h;
      if (!opts || !opts.silent) {
        toast(
          (opts && opts.label) || gridText('data-ns-t-hidden', 'Product hidden'),
          (opts && opts.undoLabel) || gridText('data-ns-t-undo', 'Undo'),
          function () { NsCurate.unhide(h); }
        );
      }
      notifyChange();
    },
    unhide: function (h) {
      if (!h) return;
      writeHidden(readHidden().filter(function (x) { return x !== h; }));
      if (lastHidden === h) lastHidden = null;
      notifyChange(true);
    },
    reset: function () { writeHidden([]); lastHidden = null; notifyChange(true); },
    undoLast: function () { if (lastHidden) NsCurate.unhide(lastHidden); },
    // Re-apply display:none to blocked products on every grid (e.g. after the
    // filters engine re-renders the grid). No event — just the visual sync.
    refresh: function () { document.querySelectorAll('ul#product-grid[data-ns-actions]').forEach(applyHidden); }
  };
  window.NsCurate = NsCurate;

  // Mutual exclusivity: favouriting a product that's currently hidden brings it
  // back (covers a direct heart tap in the Hidden review view, not just the
  // swipe-right gesture which already un-hides).
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ns-fav-btn]') : null;
    if (!btn) return;
    var card = btn.closest('[data-ns-card-handle]');
    var h = card && card.getAttribute('data-ns-card-handle');
    if (!h || !NsCurate.isHidden(h)) return;
    setTimeout(function () {
      if (NsCurate.isHidden(h) && window.NsFavorites && NsFavorites.has && NsFavorites.has(h)) NsCurate.unhide(h);
    }, 40);
  });

  // Hide (display:none) every card on this grid whose handle is on the block-list.
  function applyHidden(grid) {
    /* WITH HIDING OFF, NOTHING STAYS HIDDEN. A shopper who hid twenty pieces
       last week must not keep losing them from the grid because the feature
       was switched off — the list is left in storage, so turning it back on
       restores exactly what they had, but it is not applied while off. */
    if (grid.hasAttribute('data-ns-hide-off')) {
      grid.querySelectorAll('.ns-curate-hidden').forEach(function (li) {
        li.classList.remove('ns-curate-hidden');
      });
      return;
    }
    var set = {}; readHidden().forEach(function (h) { set[h] = 1; });
    grid.querySelectorAll('[data-ns-card-handle]').forEach(function (li) {
      var h = li.getAttribute('data-ns-card-handle');
      if (set[h]) li.classList.add('ns-curate-hidden');
      else li.classList.remove('ns-curate-hidden');
    });
  }

  // ---------- per-page reorder persistence (same as the reorder engine) ----------
  function loadOrder(key) { if (!LS) return []; try { var a = JSON.parse(localStorage.getItem(ORDER_PREFIX + key) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function saveOrder(key, arr) { if (LS) { try { localStorage.setItem(ORDER_PREFIX + key, JSON.stringify(arr)); } catch (e) {} } }
  // Custom order is allowed in EVERY view now (default, sorted, filtered). The
  // saved order is keyed by the URL context (sort/filter signature) below, so a
  // reorder inside "?sort_by=price-ascending" is stored and restored separately
  // from the default view — and a reorder inside a sort survives a refresh.
  function isCustomOrderable() { return true; }
  function currentPage() { try { var p = new URLSearchParams(location.search).get('page'); return p && /^\d+$/.test(p) ? p : '1'; } catch (e) { return '1'; } }
  // Signature of the current native view (sort + native filters + search), so
  // each distinct sorted/filtered view keeps its own arrangement. Page-handled
  // separately; client-side fav/size/hidden filters aren't in the URL so they
  // don't affect this.
  function querySig() {
    try {
      var p = new URLSearchParams(location.search);
      p.delete('page');
      var pairs = [];
      p.forEach(function (v, k) { pairs.push(k + '=' + v); });
      pairs.sort();
      return pairs.join('&');
    } catch (e) { return ''; }
  }
  function orderKeyFor(base, page) {
    var sig = querySig();
    return base + '_p' + page + (sig ? '__' + sig : '');
  }
  function applyOrder(grid, saved) {
    if (!saved || !saved.length) return;
    var items = {}, ss = {};
    grid.querySelectorAll('[data-ns-card-handle]').forEach(function (li) { items[li.getAttribute('data-ns-card-handle')] = li; });
    /* ALREADY IN ORDER: TOUCH NOTHING.

       On a page load the saved order is put in place before the first paint,
       by the inline script straight after the grid in
       main-collection-product-grid.liquid. Re-appending every card here
       anyway would move all 96 of them behind the promo tiles, and the tiles
       would sit at the front of the grid until ns-collection-promos.js put
       them back 120ms later: a visible reshuffle over a grid that was already
       right. */
    if (orderMatches(grid, saved, items)) return;
    saved.forEach(function (h) { ss[h] = 1; if (items[h]) grid.appendChild(items[h]); });
    grid.querySelectorAll('[data-ns-card-handle]').forEach(function (li) { if (!ss[li.getAttribute('data-ns-card-handle')]) grid.appendChild(li); });
  }
  /* Whether the cards already stand in the order applyOrder would produce:
     the saved handles first (a handle listed twice counts where it is listed
     last, as the appendChild loop leaves it), then the rest as they are. */
  function orderMatches(grid, saved, items) {
    var cur = grid.querySelectorAll('[data-ns-card-handle]');
    var last = {}, want = [], i;
    for (i = 0; i < saved.length; i++) last[saved[i]] = i;
    for (i = 0; i < saved.length; i++) {
      if (Object.prototype.hasOwnProperty.call(items, saved[i]) && last[saved[i]] === i) want.push(items[saved[i]]);
    }
    for (i = 0; i < cur.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(last, cur[i].getAttribute('data-ns-card-handle'))) want.push(cur[i]);
    }
    if (want.length !== cur.length) return false;
    for (i = 0; i < cur.length; i++) if (want[i] !== cur[i]) return false;
    return true;
  }

  // ---------- shared helpers ----------
  function cardHandle(li) { return li.getAttribute('data-ns-card-handle'); }
  function favourited(h) { return !!(h && window.NsFavorites && NsFavorites.has && NsFavorites.has(h)); }
  /* A card that changes ROW fades instead of sliding.

     Removing a card pushes every later card back one slot. Within a row that
     is a short hop left, which reads as the grid closing the gap — that motion
     stays. But the card at the start of a row has nowhere to go except the END
     of the row above, and animating that sends it travelling the full width of
     the grid. Watching the bottom of the page, a card arriving in the last row
     that way looks like it dropped in from somewhere above.

     So: same-row movement slides, row changes fade in place. A card that
     wraps simply appears in its new slot, like the replacement pulled from the
     next page does. */
  function fadeIntoPlace(el) {
    el.style.transition = '';
    el.style.transform = '';
    el.classList.remove('ns-curate-refill-in');
    void el.offsetWidth; // reflow, so the animation restarts if already running
    el.classList.add('ns-curate-refill-in');
    setTimeout(function () { el.classList.remove('ns-curate-refill-in'); }, 460);
  }

  function flipStep(el, dx, dy, ms) {
    // Sub-pixel noise: a card measured mid-fade is scaled to 0.96, so its rect
    // is a hair off. Animating that is invisible churn.
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
    if (Math.abs(dy) > el.getBoundingClientRect().height * 0.5) { fadeIntoPlace(el); return; }
    el.style.transition = 'none';
    el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
    requestAnimationFrame(function () {
      el.style.transition = 'transform ' + ms + 'ms cubic-bezier(.2,.8,.2,1)';
      el.style.transform = '';
    });
    setTimeout(function () { el.style.transition = ''; el.style.transform = ''; }, ms + 40);
  }

  /* afterRemove runs between hiding the card and measuring the new layout, so
     anything that needs to reposition in response does so BEFORE the browser
     paints — no intermediate frame for the shopper to see. */
  function flipOthersOnRemove(grid, card, afterRemove) {
    var els = [];
    // Promos are included so that if one does have to shift, it glides with
    // everything else rather than snapping a beat later.
    grid.querySelectorAll('[data-ns-card-handle], [data-ns-promo]').forEach(function (e) {
      if (e !== card && !e.classList.contains('ns-curate-hidden')) els.push(e);
    });
    var first = els.map(function (el) { return el.getBoundingClientRect(); });
    card.classList.add('ns-curate-hidden');
    if (afterRemove) { try { afterRemove(); } catch (e) {} }
    els.forEach(function (el, i) {
      var last = el.getBoundingClientRect();
      flipStep(el, first[i].left - last.left, first[i].top - last.top, 220);
    });
  }

  // ---------- the two actions ----------
  function doHide(grid, card) {
    var h = cardHandle(card);
    if (!h) return;
    if (favourited(h) && window.NsFavorites && NsFavorites.remove) { NsFavorites.remove(h); NsFavorites.sync(); }

    /* Re-place the promos in the SAME frame the card disappears.

       A promo is positioned "after N products". Remove a product ahead of it
       and it momentarily sits after N-1 — one cell earlier — so it slid left
       with the rest of the row, then snapped back when the debounced re-place
       caught up. Correcting it here, before the browser paints, means the
       promo simply never moves: it stays in its cell while the products flow
       around it. */
    flipOthersOnRemove(grid, card, function () {
      if (window.NsCollectionPromos && NsCollectionPromos.replace) {
        NsCollectionPromos.replace();
      }
    });

    NsCurate.hide(h);
    // The card leaves and its neighbours close the gap — that's all a hide
    // does now. The replacement is fetched later, once the end of the grid
    // comes within reach (see the ns:hidden-changed handler), so nothing
    // shifts below the fold while the shopper is looking elsewhere.
  }
  function doFavourite(card) {
    var h = cardHandle(card);
    if (NsCurate.isHidden(h)) NsCurate.unhide(h);
    var btn = card.querySelector('[data-ns-fav-btn]');
    if (btn && window.NsFavorites) {
      if (!favourited(h) && NsFavorites.addFromButton) NsFavorites.addFromButton(btn);
      else if (!favourited(h)) btn.click();
    }
    card.classList.add('ns-curate-faved-pulse');
    setTimeout(function () { card.classList.remove('ns-curate-faved-pulse'); }, 500);
    /* Both callers of this are gestures — the swipe and the drag onto the
       heart zone. Saying so lets ns-fav-swipe-hint.js retire its one-time
       "you can also swipe" demo: someone who has just done it does not need
       to be shown it. Nothing else listens, and nothing breaks if that script
       is not loaded. */
    document.dispatchEvent(new CustomEvent('ns:fav-gesture', { detail: { handle: h } }));
  }

  // ============================================================
  //  Cross-page refill: as cards are hidden, pull the next products from later
  //  pages up into the grid, so a shopper can curate the whole collection from
  //  the first page. Paused while a client-side filter (fav/size) owns the grid.
  // ============================================================
  function sectionId() { var g = document.getElementById('product-grid'); return g ? g.getAttribute('data-id') : null; }
  // Number of SHOPIFY pages in this collection (not visual pages).
  // Prefer the value Liquid stamped on the grid: once lazy paging rewrites the
  // pagination links to show visual pages (e.g. 5 pages of 96 instead of 9 of
  // 48), scraping those links under-counts and we would fetch only half the
  // catalogue. The DOM scrape stays as a fallback for older markup.
  function totalPagesDom() {
    var g = document.getElementById('product-grid');
    var stamped = g && parseInt(g.getAttribute('data-ns-total-pages'), 10);
    if (stamped > 0) return stamped;

    var nav = document.querySelector('#ProductGridContainer .pagination__list');
    if (!nav) return 1;
    var max = 1;
    nav.querySelectorAll('a, span').forEach(function (el) { var n = parseInt((el.textContent || '').trim(), 10); if (n > max) max = n; });
    return max;
  }

  // How many Shopify pages are stitched into one visual page (1 = lazy off).
  function lazyBatches() {
    var g = document.getElementById('product-grid');
    var n = g && parseInt(g.getAttribute('data-ns-lazy-batches'), 10);
    return n > 1 ? n : 1;
  }
  function nativeView() {
    // the filters engine hides pagination + replaces the grid when a client
    // filter is active; don't refill into a filtered view.
    var pw = document.querySelector('#ProductGridContainer .pagination-wrapper');
    if (pw && pw.style.display === 'none') return false;
    // A real client filter is active (fav / size / Hidden view) -> pause refill.
    // BUT ignore the "Reset hidden" pill: it's just a "you have hidden items"
    // affordance and is present whenever anything is hidden — it must NOT pause
    // refill, or hiding a card would stop pulling new ones up.
    var pills = document.querySelectorAll('[data-ns-pill-remove]');
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].getAttribute('data-ns-pill-remove') !== 'reset-hidden') return false;
    }
    return true;
  }
  function fetchSectionPage(n) {
    var sid = sectionId();
    if (!sid) return Promise.resolve([]);
    var p = new URLSearchParams(location.search);
    p.set('section_id', sid); p.set('page', n);
    return fetch(location.pathname + '?' + p.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var out = [];
        if (!html) return out;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.getElementById('product-grid');
        if (g) g.querySelectorAll('li.grid__item[data-ns-card-handle]').forEach(function (li) { out.push(li); });
        return out;
      }).catch(function () { return []; });
  }
  // Fetch the first later page the moment a shopper starts interacting with a
  // card, so a card is ready by the time their first hide finishes animating.
  // Prefetch the full re-flow list the moment a shopper starts dragging/flicking,
  // so the first hide re-flows instantly. (Only when re-flow is in play.)
  function warmRefill() {
    try {
      var g = document.getElementById('product-grid');
      if (g && reflowEnabled(g)) buildReflowList(g, function () {});
    } catch (e) {}
  }

  // ============================================================
  //  RE-FLOW PAGINATION (supersedes the reactive top-up above).
  //  When products are hidden on a multi-page collection, rebuild EVERY page from
  //  the full catalogue (minus hidden) so the collection reads as one seamless
  //  compacted list: every page full (last shorter), correct order, no gaps, no
  //  repeats — exactly as if the hidden products never existed. Paused under a
  //  client filter (fav / size / Hidden view); skipped on very large catalogues.
  // ============================================================
  var REFLOW_PAGE_CAP = 40;   // don't auto-fetch enormous catalogues
  var reflowFull = null;      // { sig, pageSize, cards:[{handle,html}] } native order
  var reflowBuilding = null;  // callbacks waiting on the build already in flight
  var REFLOW_CONCURRENCY = 4; // parallel section fetches; 40 at once invited 429s
  var reflowActive = false;   // grid currently shows a reflowed (compacted) view
  var reflowBusy = false;
  var reflowT = null;

  function reflowEnabled(grid) {
    return !!(grid && grid.hasAttribute('data-ns-refill') && nativeView()
      && totalPagesDom() > 1 && totalPagesDom() <= REFLOW_PAGE_CAP);
  }

  // Reorder an array of {handle,html} so saved-order handles lead (in saved
  // order); the rest keep native order behind them. Array twin of applyOrder().
  function applyOrderToArr(arr, saved) {
    if (!saved || !saved.length) return arr;
    var pos = {}; for (var i = 0; i < saved.length; i++) pos[saved[i]] = i;
    return arr.map(function (c, idx) { return { c: c, idx: idx }; }).sort(function (a, b) {
      var pa = pos[a.c.handle], pb = pos[b.c.handle];
      var ha = pa !== undefined, hb = pb !== undefined;
      if (ha && hb) return pa - pb;
      if (ha) return -1;
      if (hb) return 1;
      return a.idx - b.idx;
    }).map(function (x) { return x.c; });
  }

  // Fetch every page once; build the full native-ordered list with each native
  // page's saved reorder applied within it. Cached per query signature (sort).
  function buildReflowList(grid, cb) {
    var sig = querySig();
    if (reflowFull && reflowFull.sig === sig) { cb(reflowFull); return; }
    var pages = totalPagesDom();
    if (pages < 1 || pages > REFLOW_PAGE_CAP) { cb(null); return; }

    /* One in-flight build at a time.

       Every lift and every flick used to call this. Two quick gestures before
       the first batch resolved produced two full sets of page requests at once.
       Later callers now wait on the build already running. */
    if (reflowBuilding) { reflowBuilding.push(cb); return; }
    reflowBuilding = [cb];

    function finish(result) {
      var waiting = reflowBuilding;
      reflowBuilding = null;
      for (var i = 0; i < waiting.length; i++) {
        try { waiting[i](result); } catch (e) {}
      }
    }

    var base = grid.getAttribute('data-ns-collection-key') || 'default';
    var got = new Array(pages), pageSize = 0, done = 0, failed = false, next = 0;

    /* THROTTLED, AND ABANDONED IF ANY PAGE COMES BACK EMPTY.

       This used to fire one request per page in parallel — up to 40 at once —
       and fetchSectionPage swallows every failure by returning []. A single 429
       (which 40 simultaneous requests invite) or a dropped connection left a
       hole in the list, and the TRUNCATED list was then cached for the rest of
       the session as if it were the whole catalogue.

       reconcileGrid treats that list as truth and removes every card not in it,
       and fixReflowPagination hides the now-surplus page links. So one failed
       request silently deleted a page of products from the grid AND from
       pagination until the shopper reloaded or changed sort.

       A collection page always has at least one product per page, so zero cards
       back can only mean the request failed. Abandoning returns null, which
       renderReflow already handles by leaving the native view alone — the
       shopper sees the grid they had, not a damaged one. */
    function pump() {
      while (next < pages && inFlight < REFLOW_CONCURRENCY) {
        if (failed) return;
        (function (pageNum) {
          inFlight++;
          fetchSectionPage(pageNum).then(function (lis) {
            inFlight--;
            if (failed) return;

            if (!lis.length) {
              failed = true;
              finish(null); // leave the native grid intact rather than truncate it
              return;
            }

            var cards = [];
            for (var i = 0; i < lis.length; i++) {
              var h = lis[i].getAttribute('data-ns-card-handle');
              if (h) cards.push({ handle: h, html: lis[i].outerHTML });
            }
            if (cards.length > pageSize) pageSize = cards.length;
            var saved = loadOrder(orderKeyFor(base, String(pageNum)));
            got[pageNum - 1] = applyOrderToArr(cards, saved);

            if (++done === pages) {
              var flat = [];
              for (var k = 0; k < got.length; k++) if (got[k]) flat = flat.concat(got[k]);
              reflowFull = { sig: sig, pageSize: pageSize || flat.length || 1, cards: flat };
              finish(reflowFull);
              return;
            }
            pump();
          });
        })(++next);
      }
    }

    var inFlight = 0;
    pump();
  }

  // Bring the grid to exactly `slice` (in order), reusing existing DOM nodes (no
  // re-render / image flicker) and only creating the new cards that floated up.
  function reconcileGrid(grid, slice) {
    /* FIRST half of a FLIP.

       Hiding a card animates its neighbours nicely (flipOthersOnRemove), but
       the re-flow that follows a moment later used to reorder the DOM outright
       — every card teleporting to its new slot in one frame, which read as a
       page reload rather than a card being removed. Capturing positions here
       and replaying them below turns that second step into the same smooth
       slide as the first. */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pre = [];
    if (!reduceMotion) {
      grid.querySelectorAll('[data-ns-card-handle]').forEach(function (li) {
        if (li.classList.contains('ns-curate-hidden')) return;
        pre.push({ el: li, rect: li.getBoundingClientRect() });
      });
    }

    /* Minimal reconciliation.

       This used to push EVERY card of the new slice into a fragment and append
       it. appendChild on an already-attached node MOVES it, so hiding one
       product tore all 96 cards out of the grid and re-inserted them: images
       re-decoded, the browser lost its scroll anchor, the promos ended up
       stranded ahead of every product, and the FLIP below animated the whole
       grid instead of nothing. That is what made a single hide feel like a
       page reload.

       Almost every hide produces a slice that is the current order minus one
       card plus one new one at the end. Walking the two in step means exactly
       that happens to the DOM: one removal, one insertion, nothing else
       touched — and the promos, which sit between cards, are never disturbed. */
    function productNodes() {
      return Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-ns-card-handle]'));
    }

    var existing = {};
    productNodes().forEach(function (li) {
      existing[li.getAttribute('data-ns-card-handle')] = li;
    });

    var want = {};
    slice.forEach(function (c) { want[c.handle] = 1; });

    Object.keys(existing).forEach(function (h) {
      if (!want[h] && existing[h].parentNode === grid) {
        grid.removeChild(existing[h]);
        delete existing[h];
      }
    });

    var cur = productNodes();
    var ci = 0;

    slice.forEach(function (c) {
      var node = existing[c.handle];
      var atCursor = cur[ci];

      // Already in the right place — leave it completely alone.
      if (node && node === atCursor) { ci++; return; }

      if (!node) {
        var tmp = document.createElement('div');
        tmp.innerHTML = c.html;
        node = tmp.firstElementChild;
        if (!node) return;
        node.classList.remove('ns-curate-hidden');
        node.classList.add('ns-curate-refill-in');
        (function (el) { setTimeout(function () { el.classList.remove('ns-curate-refill-in'); }, 460); })(node);
        existing[c.handle] = node;
      }

      // Insert before the card currently occupying this slot (or at the end).
      grid.insertBefore(node, atCursor || null);
    });

    /* LAST / INVERT / PLAY — slide every surviving card from where it was to
       where it now is, so the grid closes the gap instead of snapping. */
    if (pre.length) {
      pre.forEach(function (p) {
        if (p.el.parentNode !== grid) return; // card left the page entirely
        var last = p.el.getBoundingClientRect();
        flipStep(p.el, p.rect.left - last.left, p.rect.top - last.top, 260);
      });
    }

    if (window.NsFavorites && NsFavorites.sync) NsFavorites.sync();
  }

  // Hide page-number links beyond the new total + the "next" arrow on the new
  // last page. Clearing display restores native pagination once nothing's hidden.
  function fixReflowPagination(totalPages, cur, batches) {
    var list = document.querySelector('#ProductGridContainer .pagination__list');
    if (!list) return;
    var b = batches > 1 ? batches : 1;
    list.querySelectorAll('li').forEach(function (li) {
      var a = li.querySelector('a, span');
      if (!a) return;
      // Visible link text is already a visual page number once lazy paging has
      // relabelled it, so compare that directly.
      var n = parseInt((a.textContent || '').trim(), 10);
      if (!isNaN(n)) { li.style.display = n > totalPages ? 'none' : ''; return; }
      // Arrows carry a raw ?page= (a Shopify page) — convert before comparing.
      var m = (a.getAttribute('href') || '').match(/[?&]page=(\d+)/);
      if (m) {
        var visual = Math.ceil(parseInt(m[1], 10) / b);
        li.style.display = visual > totalPages ? 'none' : '';
      }
    });
  }

  function renderReflow(grid) {
    /* A reflow requested while one is already fetching used to be dropped on
       the floor, not queued — so a lazy batch landing mid-fetch left its
       surplus cards in the grid with nothing scheduled to clean them up. Come
       back once the in-flight one has finished. */
    if (reflowBusy) { scheduleReflow(grid, 120); return; }
    if (!reflowEnabled(grid)) return;
    if (!readHidden().length && !reflowActive) return; // native pagination already correct
    reflowBusy = true;
    buildReflowList(grid, function (full) {
      reflowBusy = false;
      if (!full) return; // too large / failed -> leave native behaviour intact
      try {
        var hset = {}; readHidden().forEach(function (h) { hset[h] = 1; });
        var visible = full.cards.filter(function (c) { return !hset[c.handle]; });

        // A "page" here is what the shopper sees. With lazy paging that is
        // several Shopify pages stitched together (2 x 48 = 96), so both the
        // slice size and the current page have to be in visual units — using
        // Shopify's 48 would compact the grid back down to half a page.
        var batches = lazyBatches();
        var ps = (full.pageSize || 48) * batches;
        var totalPages = Math.max(1, Math.ceil(visible.length / ps));
        var shopifyCur = Math.max(1, parseInt(currentPage(), 10) || 1);
        var cur = Math.min(Math.ceil(shopifyCur / batches), totalPages);
        var slice = visible.slice((cur - 1) * ps, cur * ps);
        reconcileGrid(grid, slice);
        fixReflowPagination(totalPages, cur, batches);
        reflowActive = readHidden().length > 0;
      } catch (e) { /* fail safe: keep the native view */ }
    });
  }
  function scheduleReflow(grid, delay) {
    clearTimeout(reflowT);
    reflowT = setTimeout(function () { renderReflow(grid); }, delay == null ? 250 : delay);
  }

  /* ON A PAGE LOAD THE RE-FLOW USUALLY HAS NOTHING TO DO, AND WHEN IT DOES IT
     WAITS UNTIL THE PAGE HAS FINISHED LOADING.

     Measured 23 Sep 2026 on a 361-product collection with ONE hidden product:
     every reload fetched all four pages of the collection (the one already on
     screen included), 3.4MB of HTML to parse, starting the moment the
     document had parsed and competing with the images for the whole of the
     load. Then the grid was rebuilt. Owner: the reload is "slow and jumpy".

     The rebuild can only change the page the shopper is looking at when a
     hidden product is on it (its slot has to be filled from the next page),
     when an earlier page lost one (this page then starts later), or when so
     many are hidden that the last page would empty (the pagination changes).
     On page one with nothing hidden on it, none of those can be true, and the
     four requests bought nothing. Nobody loses the instant refill: the first
     touch on a card still warms the full list (warmRefill), exactly as it
     does for a shopper who has never hidden anything.

     When it IS needed, it runs once the page is complete and the browser is
     idle. The dismissed cards are already out of sight before the first
     paint (the inline script after the grid), so all that is left to arrive
     is the replacement at the end of the page. */
  function loadReflow(grid) {
    var hidden = readHidden();
    if (!hidden.length) return; // renderReflow would return here anyway
    var needed = lazyBatches() > 1 || currentPage() !== '1';
    if (!needed) {
      var set = {};
      hidden.forEach(function (h) { set[h] = 1; });
      var cards = grid.querySelectorAll('[data-ns-card-handle]');
      for (var i = 0; i < cards.length && !needed; i++) {
        if (set[cards[i].getAttribute('data-ns-card-handle')] === 1) needed = true;
      }
    }
    if (!needed) {
      // hidden.length is every hidden product in the store, so this can only
      // over-count the ones in this collection: a safe upper bound.
      var total = parseInt(grid.getAttribute('data-ns-total-items'), 10);
      var size = parseInt(grid.getAttribute('data-ns-page-size'), 10);
      var onLast = total - (totalPagesDom() - 1) * size;
      if (!(total > 0 && size > 0) || hidden.length >= onLast) needed = true;
    }
    if (!needed) return;

    // A sort or filter before load hands Dawn a new grid, whose own init()
    // schedules its own re-flow; this one is then for a grid that is gone.
    function go() { if (grid.isConnected) scheduleReflow(grid, 0); }
    function run() {
      if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 2000 });
      else setTimeout(go, 200);
    }
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  /* FINGERS ON THE SCREEN RIGHT NOW (audit, 2 Oct 2026). A card gesture belongs
     to one finger. Counted on the document, so a second finger anywhere — a
     pinch to zoom — is seen even when it lands outside the grid. The end of
     every touch sequence clears the count, so a lost pointerup cannot block
     the gestures for good. */
  var touchesDown = {};
  function fingers() { return Object.keys(touchesDown).length; }
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') touchesDown[e.pointerId] = 1;
  }, true);
  ['pointerup', 'pointercancel'].forEach(function (type) {
    document.addEventListener(type, function (e) { delete touchesDown[e.pointerId]; }, true);
  });
  ['touchend', 'touchcancel'].forEach(function (type) {
    document.addEventListener(type, function (e) { if (!e.touches || !e.touches.length) touchesDown = {}; }, true);
  });

  // ============================================================
  //  Gesture engine: reorder (lift/FLIP) + swipe + zones
  // ============================================================
  function setupGrid(grid, key, persist) {
    if (grid.dataset.nsSort === '1') return;
    grid.dataset.nsSort = '1';
    var mode = grid.getAttribute('data-ns-actions') || 'swipe';
    /* The favourite half of the feature, on its own. Left swipes spring back,
       no card lifts, and the drop zones never appear. */
    var favOnly = grid.hasAttribute('data-ns-hide-off');
    /* Product cards only. Collection promos are inert: they can't be lifted,
       and because every gesture lookup (including the reorder hit-test) goes
       through this selector, a product being dragged never treats a promo as
       something to displace either. They just sit where they were placed. */
    var SEL = '[data-ns-card-handle]';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var drag = null, ph = null, hold = null, started = false, didDrag = false, pid = null;
    var swiping = false, swStart = 0, cardW = 0;
    var sx = 0, sy = 0, cx = 0, cy = 0, offX = 0, offY = 0, w = 0, h = 0, touch = false;
    var rafLoop = null, zoneEls = null, overDrop = null, useZones = false, origNext = null;

    function commit() {
      if (!persist) return;
      // While a reflowed (compacted) view is showing, this page holds cards from
      // several native pages — saving that as the page's order would corrupt the
      // per-page arrangement, so skip persistence until curation is cleared.
      if (reflowActive) return;
      var order = [];
      grid.querySelectorAll(SEL).forEach(function (c) {
        // Save only cards that natively belong to this page and are visible.
        // Refilled (cross-page) and hidden cards are transient curation helpers,
        // so they never pollute the saved arrangement (which must round-trip on a
        // fresh page-1 load).
        if (c.classList.contains('ns-curate-hidden') || c.hasAttribute('data-ns-refilled')) return;
        order.push(c.getAttribute('data-ns-card-handle'));
      });
      saveOrder(key, order);
    }
    /* Slide the neighbours into their new places (FLIP).

       It stuttered every time the held card passed a neighbour's centre
       (owner, 2026-09-15), for two reasons, both fixed here:
       - every card on the page (~100) was measured and moved, although only
         the few on screen can be seen sliding;
       - reads and writes alternated: each card's new position was read right
         after the previous card's transform was written, which forced the
         browser to lay the page out again for EVERY card. All new positions
         are now read first, then all transforms written, then released in
         one frame. */
    function flipOthers(fn) {
      if (reduce) { fn(); return; }
      var vh = window.innerHeight, pad = vh * 0.5;
      var els = [], first = [];
      grid.querySelectorAll(SEL).forEach(function (e) {
        if (e === drag) return;
        var r = e.getBoundingClientRect();
        if (r.bottom < -pad || r.top > vh + pad) return; // off screen: nothing to see
        els.push(e); first.push(r);
      });
      fn();
      var last = els.map(function (el) { return el.getBoundingClientRect(); });
      var moved = [];
      els.forEach(function (el, i) {
        var dx = first[i].left - last[i].left, dy = first[i].top - last[i].top;
        if (dx || dy) {
          el.style.transition = 'none';
          el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
          moved.push(el);
        }
      });
      if (moved.length) {
        requestAnimationFrame(function () {
          moved.forEach(function (el) { el.style.transition = 'transform 200ms ease'; el.style.transform = ''; });
        });
      }
    }
    function positionGhost() { drag.style.left = cx - offX + 'px'; drag.style.top = cy - offY + 'px'; }

    // ---- zones (bin + heart), created lazily, shown only while lifting ----
    function ensureZones() {
      if (zoneEls) return;
      var wrap = document.createElement('div');
      wrap.className = 'ns-curate-zones';
      wrap.innerHTML =
        '<div class="ns-curate-zone ns-curate-zone--hide" data-zone="hide"><span class="ns-curate-zone__icon">' + ICON_BIN + '</span></div>' +
        '<div class="ns-curate-zone ns-curate-zone--fav" data-zone="fav"><span class="ns-curate-zone__icon">' + ICON_HEART + '</span></div>';
      document.body.appendChild(wrap);
      zoneEls = wrap;
    }
    function showZones(on) {
      if (!useZones) return;
      ensureZones();
      zoneEls.classList.toggle('is-active', on);
      /* The icons have just been created or re-shown, so any boxes measured
         for a previous lift are stale. Cleared rather than re-measured here:
         detectDrop measures on its first call, by which point the zones have
         been laid out. */
      zoneBoxes = null;
      if (!on) { overDrop = null; zoneEls.querySelectorAll('.ns-curate-zone').forEach(function (z) { z.classList.remove('is-over'); }); }
    }
    // Which drop target the lifted card is over — the bin/heart icons, with a
    // generous catch radius so you can drag *towards* an icon without landing
    // dead-on it. Reordering happens anywhere away from the two icons.
    /* The bin and the heart are fixed to the viewport and never move while a
       card is held, so their boxes are measured once when the zones appear
       rather than on every frame — two querySelectorAll calls and two
       getBoundingClientRect calls per frame, for icons that are standing
       still. Same reasoning as the card boxes above. */
    var zoneBoxes = null;
    var lastZoneKind;
    function measureZones() {
      zoneBoxes = [];
      if (!zoneEls) return;
      zoneEls.querySelectorAll('.ns-curate-zone').forEach(function (el) {
        var r = el.getBoundingClientRect();
        zoneBoxes.push({ el: el, kind: el.getAttribute('data-zone'),
                         left: r.left, top: r.top, right: r.right, bottom: r.bottom });
      });
      lastZoneKind = undefined;
    }
    function detectDrop(x, y) {
      if (!useZones || !zoneEls) return null;
      if (!zoneBoxes) measureZones();
      var kind = null, m = 56; // catch radius around each icon
      for (var i = 0; i < zoneBoxes.length; i++) {
        var b = zoneBoxes[i];
        if (x >= b.left - m && x <= b.right + m && y >= b.top - m && y <= b.bottom + m) kind = b.kind;
      }
      /* Only written when it actually changes. Toggling a class on every
         frame invalidates style for the whole subtree each time, for a value
         that is the same as the frame before it in all but a few frames. */
      if (kind !== lastZoneKind) {
        for (var j = 0; j < zoneBoxes.length; j++) {
          zoneBoxes[j].el.classList.toggle('is-over', zoneBoxes[j].kind === kind);
        }
        lastZoneKind = kind;
      }
      return kind;
    }

    function start() {
      started = true; didDrag = true;
      warmRefill(); // a real lift began -> start fetching the next page
      origNext = drag.nextElementSibling; // remember the slot, to snap favourites back to it
      var rect = drag.getBoundingClientRect();
      w = rect.width; h = rect.height;
      offX = cx - rect.left; offY = cy - rect.top;
      ph = document.createElement('li');
      ph.className = 'grid__item ns-fav-placeholder';
      ph.style.height = h + 'px';
      drag.parentNode.insertBefore(ph, drag);
      drag.classList.add('ns-fav-dragging');
      drag.style.position = 'fixed'; drag.style.zIndex = '999';
      drag.style.width = w + 'px'; drag.style.height = h + 'px'; drag.style.margin = '0';
      document.body.classList.add('ns-fav-sorting');
      document.documentElement.classList.add('ns-curate-clipx');
      positionGhost();
      var landed = drag.getBoundingClientRect();
      offX += landed.left - rect.left; offY += landed.top - rect.top;
      positionGhost();
      // Touch swipe mode uses the flick gesture for hide/favourite, so its lift is
      // pure reorder (no icons). Everywhere else (zones mode, or any desktop lift)
      // the bin + heart icons appear and you drag the card onto them.
      useZones = (mode === 'zones') || (mode === 'swipe' && !touch);
      showZones(true);
      /* Measured here, while the gesture is still settling, so the first
         frames of the drag are not paying for it. */
      cardBoxes = null;
      lastRx = -9999; lastRy = -9999;
      measureCards();
      rafLoop = requestAnimationFrame(tick);
    }
    /* WHERE THE CARDS ARE, MEASURED ONCE (owner, 20 Sep 2026 — the same
       stutter as the phone had, now on desktop and tablet).

       reorder() used to ask the browser what was under the pointer on EVERY
       frame: it set pointer-events on the held card, called
       elementFromPoint, and set it back. Each of those is a forced
       synchronous layout plus a full hit test, sixty times a second, over a
       grid of a hundred cards — and it ran on every device, which is why
       fixing the FLIP half in September only helped so much.

       The grid does not move while a card is held, except when a reorder
       itself moves it. So the positions are measured once, and re-measured
       only after a reorder actually happens. Finding the target is then
       arithmetic against that list: no layout, no hit test, nothing for the
       browser to recompute mid-gesture.

       Kept in DOCUMENT coordinates on purpose. The drag auto-scrolls near the
       edges, and viewport coordinates would go stale the instant it did;
       document coordinates only change when the cards themselves move. */
    var cardBoxes = null;
    function measureCards() {
      var sx = window.scrollX || window.pageXOffset || 0;
      var sy = window.scrollY || window.pageYOffset || 0;
      var vh = window.innerHeight, pad = vh * 0.75;
      cardBoxes = [];
      grid.querySelectorAll(SEL).forEach(function (el) {
        if (el === drag) return;
        var r = el.getBoundingClientRect();
        if (r.bottom < -pad || r.top > vh + pad) return; // can't be dragged onto
        cardBoxes.push({
          el: el,
          left: r.left + sx,
          top: r.top + sy,
          right: r.right + sx,
          bottom: r.bottom + sy,
          midX: r.left + sx + r.width / 2,
        });
      });
    }

    var lastRx = -9999, lastRy = -9999;
    function reorder() {
      if (overDrop) return; // hovering a drop target — don't reshuffle the grid
      var sx = window.scrollX || window.pageXOffset || 0;
      var sy = window.scrollY || window.pageYOffset || 0;
      var dx = cx + sx, dy = cy + sy;
      /* Nothing has moved far enough to land on a different card. Four pixels
         is well under a card's width and stops a resting hand re-running the
         search every frame. */
      if (Math.abs(dx - lastRx) < 4 && Math.abs(dy - lastRy) < 4) return;
      lastRx = dx; lastRy = dy;

      if (!cardBoxes) measureCards();
      var target = null;
      for (var i = 0; i < cardBoxes.length; i++) {
        var b = cardBoxes[i];
        if (dx >= b.left && dx <= b.right && dy >= b.top && dy <= b.bottom) { target = b; break; }
      }
      if (!target || target.el === drag || target.el.parentNode !== grid) return;
      var before = dx < target.midX;
      var el = target.el;
      flipOthers(function () { if (before) grid.insertBefore(ph, el); else grid.insertBefore(ph, el.nextSibling); });
      /* The grid has just moved, so the measurements are stale. Re-measured on
         the next frame rather than now, so this does not become the very
         forced layout it exists to avoid. */
      cardBoxes = null;
    }
    function tick() {
      if (!started) { rafLoop = null; return; }
      rafLoop = requestAnimationFrame(tick);
      positionGhost();
      overDrop = detectDrop(cx, cy);
      drag.classList.toggle('ns-curate-over-zone', !!overDrop);
      if (!overDrop) {
        var edge = 90, vh = window.innerHeight, sp = 0;
        if (cy < edge) sp = -Math.max(2, Math.ceil((edge - cy) / 6));
        else if (cy > vh - edge) sp = Math.max(2, Math.ceil((cy - (vh - edge)) / 6));
        if (sp) window.scrollBy(0, sp);
      }
      reorder();
    }
    function end() {
      if (rafLoop != null) { cancelAnimationFrame(rafLoop); rafLoop = null; }
      if (started) {
        var z = overDrop;
        var card = drag;
        var fromRect = card.getBoundingClientRect(); // lifted (fixed) position, for the snap-back
        // Favourite returns the card to the slot it was lifted from (not wherever
        // the reorder drag left the placeholder). Reorder commits at the placeholder.
        if (z === 'fav') {
          if (origNext && origNext.parentNode === grid) grid.insertBefore(card, origNext);
          else grid.appendChild(card);
          if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
        } else if (ph && ph.parentNode) {
          ph.parentNode.insertBefore(card, ph); ph.parentNode.removeChild(ph);
        }
        card.classList.remove('ns-fav-dragging', 'ns-curate-over-zone');
        card.style.position = ''; card.style.zIndex = ''; card.style.width = '';
        card.style.height = ''; card.style.margin = ''; card.style.left = ''; card.style.top = '';
        showZones(false);
        if (z === 'fav') {
          // animate from the lifted position back into the original slot
          var toRect = card.getBoundingClientRect();
          var ddx = fromRect.left - toRect.left, ddy = fromRect.top - toRect.top;
          if ((ddx || ddy) && !reduce) {
            card.style.transition = 'none';
            card.style.transform = 'translate(' + ddx + 'px,' + ddy + 'px)';
            requestAnimationFrame(function () { card.style.transition = 'transform 220ms cubic-bezier(.2,.8,.2,1)'; card.style.transform = ''; });
            setTimeout(function () { card.style.transition = ''; card.style.transform = ''; }, 260);
          }
          doFavourite(card);
        } else if (z === 'hide') {
          doHide(grid, card);
        } else {
          commit();
        }
      }
      document.body.classList.remove('ns-fav-sorting');
      document.documentElement.classList.remove('ns-curate-clipx');
      started = false; drag = null; ph = null;
      clearTimeout(hold);
      detach();
    }

    // ---- swipe (touch only) ----
    function startSwipe() {
      swiping = true; didDrag = true; swStart = Date.now();
      warmRefill(); // a real flick began -> start fetching the next page
      cardW = drag.getBoundingClientRect().width || 1;
      drag.classList.add('ns-curate-swiping');
      document.documentElement.classList.add('ns-curate-clipx'); // stop the page widening as the card slides
    }
    function swipeMove() {
      var dx = cx - sx;
      // A right swipe carried back past where it started stops at the slot:
      // with hiding off the card has nowhere to go on the left.
      if (favOnly && dx < 0) dx = 0;
      var rot = Math.max(-8, Math.min(8, dx * 0.04));
      drag.style.transition = 'none';
      drag.style.transform = 'translateX(' + dx + 'px) rotate(' + rot + 'deg)';
      drag.style.opacity = Math.max(0.35, 1 - Math.abs(dx) / (cardW * 1.3));
      drag.classList.toggle('ns-curate-hint-hide', !favOnly && dx < -10);
      drag.classList.toggle('ns-curate-hint-fav', dx > 10);
    }
    function endSwipe() {
      var dx = cx - sx;
      if (favOnly && dx < 0) dx = 0; // see swipeMove
      var adx = Math.abs(dx);
      var fast = (Date.now() - swStart) < 300 && adx > cardW * 0.18;
      var commitAction = adx > cardW * 0.35 || fast;
      drag.classList.remove('ns-curate-hint-hide', 'ns-curate-hint-fav');
      var card = drag;
      if (commitAction && dx < 0 && !favOnly) {
        // hide — fly off then close the gap
        card.style.transition = 'transform 160ms ease, opacity 160ms ease';
        card.style.transform = 'translateX(-' + (cardW + 80) + 'px) rotate(-8deg)';
        card.style.opacity = '0';
        setTimeout(function () {
          card.style.transition = ''; card.style.transform = ''; card.style.opacity = '';
          card.classList.remove('ns-curate-swiping');
          doHide(grid, card);
        }, 165);
      } else if (commitAction && dx > 0) {
        // favourite — snap back, heart turns red
        card.style.transition = 'transform 220ms ease, opacity 220ms ease';
        card.style.transform = ''; card.style.opacity = '';
        setTimeout(function () { card.style.transition = ''; card.classList.remove('ns-curate-swiping'); }, 230);
        doFavourite(card);
      } else {
        // spring back
        card.style.transition = 'transform 200ms ease, opacity 200ms ease';
        card.style.transform = ''; card.style.opacity = '';
        setTimeout(function () { card.style.transition = ''; card.classList.remove('ns-curate-swiping'); }, 210);
      }
      setTimeout(function () { document.documentElement.classList.remove('ns-curate-clipx'); }, 280);
      swiping = false; drag = null;
      clearTimeout(hold);
      detach();
    }

    /* Ends the gesture without acting: nothing has travelled, so a swipe
       springs back and a lifted card stays where it is. */
    function cancelGesture() {
      cx = sx; cy = sy; overDrop = null;
      if (swiping) endSwipe(); else end();
    }

    function onMove(e) {
      if (e.pointerId !== pid) return;                       // another finger
      if (touch && fingers() > 1) { cancelGesture(); return; } // a pinch began
      cx = e.clientX; cy = e.clientY;
      if (!drag) return;
      if (swiping) { e.preventDefault(); swipeMove(); return; }
      if (!started) {
        var dx = cx - sx, dy = cy - sy, adx = Math.abs(dx), ady = Math.abs(dy);
        if (touch) {
          if (mode === 'swipe') {
            if (adx < 8 && ady < 8) return;               // wait for a clear direction
            if (ady > adx * 1.8) { clearTimeout(hold); end(); return; } // CLEARLY vertical -> let it scroll
            /* WITH HIDING OFF, A LEFT SWIPE IS NOT A GESTURE AT ALL (owner,
               23 Sep 2026: with hidden products turned off the swipe to the
               left should be off on every device, and saving by swiping
               should keep working). It used to start a swipe anyway and
               spring back, so the card still slid left, tilted and faded —
               the feature looked switched on and simply broken. Now the card
               is let go before it moves. Swiping right is untouched. */
            if (favOnly && dx < 0 && adx > 10 && adx > ady) { clearTimeout(hold); end(); return; }
            if (adx > 10 && adx > ady) { clearTimeout(hold); startSwipe(); e.preventDefault(); return; } // horizontal wins -> flick
            return;
          }
          if (adx + ady > 12) { clearTimeout(hold); end(); return; } // zones mode: movement before hold = scroll
          return;
        }
        // Rearranging is part of the hiding feature, so a mouse drag does
        // nothing when it is off.
        if (favOnly) return;
        if (adx + ady > 6) start(); else return; // mouse: press-drag reorders
      }
      e.preventDefault();
    }
    function onUp(e) { if (e && e.pointerId !== pid) return; if (swiping) endSwipe(); else end(); }
    function onTouchMove(e) { if (started || swiping) e.preventDefault(); }
    function detach() {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
    }

    grid.addEventListener('dragstart', function (e) { e.preventDefault(); });
    grid.addEventListener('contextmenu', function (e) { if (touch) e.preventDefault(); });
    grid.addEventListener('pointerdown', function (e) {
      if (e.button != null && e.button !== 0) return;
      /* ONE FINGER PER GESTURE (audit, 2 Oct 2026). Any pointerdown used to
         re-target the gesture and any finger's move steered it, so a pinch with
         a finger on each of two cards read as a right swipe and saved one of
         them to favourites. A second finger now ends the gesture without acting
         and starts nothing itself. */
      if (e.pointerType === 'touch' && fingers() > 1) { if (drag) cancelGesture(); return; }
      if (drag) cancelGesture(); // a gesture whose lift never arrived
      var card = e.target.closest(SEL);
      if (!card || card.classList.contains('ns-curate-hidden')) return;
      didDrag = false;
      if (e.target.closest('button') || e.target.closest('.ns-card-swatch') || e.target.closest('input') || e.target.closest('label')) return;
      drag = card; pid = e.pointerId; sx = cx = e.clientX; sy = cy = e.clientY; started = false; swiping = false;
      touch = e.pointerType === 'touch';
      clearTimeout(hold);
      // No hold-to-lift when rearranging is off; a long press then simply
      // does nothing, and a horizontal flick is still read as a swipe.
      if (touch && !favOnly) hold = setTimeout(start, 250);
      document.addEventListener('pointermove', onMove, { passive: false });
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    });
    grid.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);
  }

  // ---------- icons (inline so they work in the JS-built zones) ----------
  // --- hide-zone icon ---
  // Both zone icons are drawn in the same 24x24 viewBox at stroke-width 1 so they
  // read as one set. ns-collection-curate.css sizes every zone svg to 4.6rem, so
  // matched height comes from filling the same span of the viewBox — not from the
  // width/height attributes. The heart spans y 2.7-20.3 (17.6 units); the cross
  // spans exactly the same, so both render at the same pixel height.
  //
  // To REVERT, change the ICON_BIN line below to ICON_BIN_CART or ICON_BIN_ELEGANT.
  // Old (cart drawer icon-remove.svg) — kept so we can switch back instantly.
  var ICON_BIN_CART = '<svg class="icon icon-remove" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>';
  // New: refined thin-stroke bin — tapered body, soft rounded joins, matches the
  // outline heart. Premium/editorial feel.
  var ICON_BIN_ELEGANT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 6.5h16"/><path d="M9.5 6.5V5.4c0-.66.54-1.2 1.2-1.2h2.6c.66 0 1.2.54 1.2 1.2v1.1"/><path d="M6.4 6.5l.77 11.2c.06.9.8 1.6 1.7 1.6h6.26c.9 0 1.64-.7 1.7-1.6l.77-11.2"/><path d="M10 10.3v5.4M14 10.3v5.4"/></svg>';
  // Fine-line cross, sized to the heart: y 2.7-20.3, centred on x 12.
  var ICON_CROSS = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M3.2 2.7 20.8 20.3M20.8 2.7 3.2 20.3"/></svg>';
  var ICON_BIN = ICON_CROSS;
  var ICON_HEART = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.78 2 4.92 4.2 2.7 7 2.7c1.74 0 3.4.86 4.45 2.23l.55.72.55-.72A5.5 5.5 0 0 1 17 2.7c2.8 0 5 2.22 5 5.08 0 3.5-3.4 6.58-8.55 11.2L12 20.3z" fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/></svg>';

  // ---------- init ----------
  // The FIRST init() (a real page load — reload, or navigating back to the page)
  // restores the saved arrangement for the current sort/filter context. Later
  // init()s come from Dawn re-rendering the grid after the shopper CHANGES the
  // sort/filter — in that case we show the freshly-sorted order and do NOT
  // overwrite it, so "I just activated the sort" and "I reloaded" behave
  // differently (the exact distinction that was missing).
  var booted = false;
  function init() {
    var grids = document.querySelectorAll('ul#product-grid[data-ns-actions]');
    if (!grids.length) return; // nothing here yet -> don't consume the page-load flag
    var isPageLoad = !booted;
    booted = true;
    if (!isPageLoad) { reflowFull = null; reflowActive = false; } // new sort/filter context -> rebuild
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      applyHidden(grid);
      if (grid.dataset.nsReady === '1') continue;
      grid.dataset.nsReady = '1';
      var base = grid.getAttribute('data-ns-collection-key') || 'default';
      var page = currentPage();
      var k = orderKeyFor(base, page);
      var orderable = isCustomOrderable();
      if (isPageLoad && orderable) applyOrder(grid, loadOrder(k)); // restore only on a real load
      // The grid was hidden before first paint (see the inline script in
      // main-collection-product-grid.liquid) precisely so the pre-reorder
      // arrangement never flashes. It is safe to show now.
      grid.classList.remove('ns-order-pending');
      setupGrid(grid, k, orderable);
      // On a real load with products already hidden, re-flow this page so its
      // count is correct (fixes "page 2 is short after curating page 1").
      // A page load goes through loadReflow: see the note there.
      if (reflowEnabled(grid)) {
        if (isPageLoad) loadReflow(grid);
        else scheduleReflow(grid, 0);
      }
    }
  }
  var moT = null;
  function scheduleInit() { clearTimeout(moT); moT = setTimeout(init, 60); }
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var nd = nodes[j];
          if (nd.nodeType !== 1) continue;
          if ((nd.matches && nd.matches('ul#product-grid[data-ns-actions]')) ||
              (nd.querySelector && nd.querySelector('ul#product-grid[data-ns-actions]'))) { scheduleInit(); return; }
        }
      }
    });
    try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }
  /* Top up as soon as a product is hidden.

     I tried deferring this until the shopper scrolled near the end of the grid
     — the idea being that nothing should change below the fold. But the
     scroll-triggered top-up did not fire reliably, so replacements simply
     stopped arriving and the grid quietly got shorter with every hide. Reverted
     to topping up immediately, which is correct even if it is less clever.
     Worth revisiting, but only with a trigger that is actually proven. */
  /* The keyboard route to hiding.

     Delegated from the document, so it keeps working through every grid
     rebuild — sorts, filters and lazy batches all replace the cards. It calls
     the same NsCurate.hide() the gestures do, so the re-flow, the undo toast
     and the cross-collection block-list behave identically; this is a second
     door onto the same room, not a parallel implementation.

     Focus is moved to the undo control afterwards. Hiding something with a
     keyboard removes the element you were standing on, and without this the
     focus point is destroyed and the browser dumps you back at the top of the
     document — with the only undo sitting in a toast you would have to hunt
     for before it times out. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ns-kbd-hide]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-ns-kbd-hide');
    if (!handle) return;
    NsCurate.hide(handle);
    setTimeout(function () {
      var undo = toastEl && toastEl.querySelector('.ns-curate-toast__action');
      if (undo) undo.focus();
    }, 60);
  });

  document.addEventListener('ns:hidden-changed', function () {
    document.querySelectorAll('ul#product-grid[data-ns-actions]').forEach(function (g) {
      applyHidden(g);
      // Covers hide, unhide and "reset hidden" — and restores native
      // pagination when the last hidden product is brought back.
      if (reflowEnabled(g)) scheduleReflow(g, 280);
    });
  });

  /* A lazy batch landing is a grid change too.

     This is what made hiding look random near the bottom. On a page opened
     with products already hidden, two engines fill the grid and they race:

       - the re-flow curates the page to exactly one visual page of VISIBLE
         products, pulling cards up from page 3 to stand in for the hidden ones;
       - ns-collection-lazy-pages appends Shopify page 2, skipping handles that
         are already on screen.

     Whichever finishes second decides the outcome. When the re-flow got there
     first, the batch then appended the very cards the re-flow had just
     displaced — leaving the grid a couple of cards TOO LONG, and nothing ever
     told the re-flow about it.

     The surplus then sat there until the next hide, whose reconcile finally
     trimmed the grid back: two cards yanked out at once and, when the orders
     had drifted far enough, a card relocated across the grid — which the FLIP
     dutifully animated from wherever it used to be, usually from somewhere
     above. That is the card that appeared to be "pulled in from the top", and
     it only happened when the race went that way, which is why it seemed to
     come and go at random.

     Reconciling as soon as the batch lands moves that correction to page load,
     where it is below the fold and costs nothing. Every hide then starts from a
     correct grid, so it stays what it should be: one card leaves, its
     neighbours slide up a slot, one card fades in at the end. */
  document.addEventListener('ns:cards-appended', function (e) {
    var g = (e.detail && e.detail.grid) || document.querySelector('ul#product-grid[data-ns-actions]');
    if (g && reflowEnabled(g)) scheduleReflow(g, 60);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
